import { useMutation } from "@tanstack/react-query";

import apiClient from "@app/common/api/apiClient";

const useSendTopicReport = () => {
  const shareTopicReportToSlack = useMutation({
    mutationFn: apiClient.integrations.slack.postTopicToConversation,
  });

  const shareTopicReportToTeams = useMutation({
    mutationFn: apiClient.integrations.teams.postTopicToConversation,
  });

  const shareTopicReportViaEmail = useMutation({
    mutationFn: apiClient.topics.shareViaEmail,
  });

  return {
    shareTopicReportToSlack,
    shareTopicReportToTeams,
    shareTopicReportViaEmail,
  };
};

export default useSendTopicReport;
